import React from 'react';
import { Link } from 'react-router-dom';
import {
  getPrintJobNotificationDownload,
  getPrintJobNotificationEditionId,
  getPrintJobNotificationEditionTitle,
  getPrintJobNotificationFileNames,
  getPrintJobNotificationPdfSummary,
} from 'helpers/printJobNotificationDownloads';

const labelStyle = {
  flex: '0 0 auto',
  whiteSpace: 'nowrap',
};

const titleWrapStyle = {
  flex: '1 1 0%',
  minWidth: 0,
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};

const linkStyle = {
  cursor: 'pointer',
  textDecoration: 'underline',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};

/**
 * Shared Edition / PDF context for print-job notifications (toast, menu, profile).
 * Supports single-file and multi-file (printDataSplit) without overlapping the label.
 */
const PrintJobNotificationContext = ({ notification, appIntl, messages, compact = false }) => {
  const download = getPrintJobNotificationDownload(notification);
  const editionId = getPrintJobNotificationEditionId(notification);
  const editionTitle = getPrintJobNotificationEditionTitle(notification);
  if (!download && !editionTitle) {
    return null;
  }

  const editionLabel = messages.edition || 'Edition';
  const pdfSummary = getPrintJobNotificationPdfSummary(notification, messages);
  const fileNames = getPrintJobNotificationFileNames(download);

  return (
    <div
      className="print-job-notification-context m-t-5"
      style={{ minWidth: 0, maxWidth: '100%', lineHeight: 1.35 }}
    >
      {editionTitle && (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 6,
            minWidth: 0,
            width: '100%',
          }}
        >
          <strong style={labelStyle}>{editionLabel}:</strong>
          <span style={titleWrapStyle}>
            {editionId ? (
              <Link
                to={appIntl.urlPrefix + 'editor/' + editionId}
                className="text-primary text-decoration-underline"
                style={linkStyle}
                onClick={event => event.stopPropagation()}
              >
                {editionTitle}
              </Link>
            ) : (
              editionTitle
            )}
          </span>
        </div>
      )}
      {download && pdfSummary && (
        <div style={{ marginTop: compact ? 4 : 6, minWidth: 0 }}>
          <strong>PDF:</strong> {pdfSummary}
          {fileNames.length > 1 && !compact && (
            <ul className="m-t-5 m-b-0" style={{ paddingLeft: 18, marginBottom: 0 }}>
              {fileNames.map(name => (
                <li key={name} style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                  {name}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default PrintJobNotificationContext;
